import { render, staticRenderFns } from "./pavertable.vue?vue&type=template&id=1b1ebb0e&scoped=true&"
import script from "./pavertable.vue?vue&type=script&lang=js&"
export * from "./pavertable.vue?vue&type=script&lang=js&"
import style0 from "./pavertable.vue?vue&type=style&index=0&id=1b1ebb0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ebb0e",
  null
  
)

export default component.exports